/* Fixed set of on-brand accent choices for blog categories.
   This is design-system config (ties category colors to the site's
   existing CSS variables) — not blog content. Blog content itself
   (posts, categories, everything editorial) lives in Firestore and
   is managed entirely through the admin panel. */

export const BLOG_PALETTE = [
  { key: 'blue', label: 'Blue', accent: 'var(--blue)', rgb: '0,60,255' },
  { key: 'red', label: 'Red', accent: 'var(--red)', rgb: '255,0,4' },
  { key: 'ink', label: 'Ink', accent: 'var(--ink)', rgb: '10,10,20' },
  { key: 'blue-deep', label: 'Deep Blue', accent: 'var(--blue-deep)', rgb: '0,40,170' },
  { key: 'red-deep', label: 'Deep Red', accent: 'var(--red-deep)', rgb: '255,0,72' },
  { key: 'ink-soft', label: 'Soft Ink', accent: 'var(--ink-soft)', rgb: '42,42,58' },
];

export function paletteByKey(key) {
  return BLOG_PALETTE.find((p) => p.key === key) || BLOG_PALETTE[0];
}
